export class ErrorModalLabel_EN {

    modal: {
        logout: string;
        home: string;
        yesBtn: string;
        noBtn: string;
    }

    constructor() {

        this.modal = {
            logout: "Do you want to logout ?",
            home: "You have entered new data on this page. If you navigate away from this page without first saving your data, the changes will be lost.",
            yesBtn: "Yes",
            noBtn: "No"
        }
    }
}